import type { ButtonVariant } from "@/components/ui/button";

export function buttonVariant(value: unknown, fallback: ButtonVariant = "teal"): ButtonVariant {
  switch (value) {
    case "red":
      return "orange";
    case "navy":
      return "navy";
    case "white":
      return "white";
    case "teal":
      return "teal";
    default:
      return fallback;
  }
}
